'use strict';
var parent = require('../../es/array/includes');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/stable/array/includes.js
// module id = 490
// module chunks = 0